<template lang="html">
  <!-- Content -->
  <d-row>
    <d-col lg="9">
      <d-card class="card-small mb-4">
        <!-- Card Header -->
        <d-card-header class="border-bottom">
          <d-row class="align-items-center">
            <d-col cols="12" lg="4">
              <h6 class="m-0">Informações do produto</h6>
            </d-col>
          </d-row>
        </d-card-header>

        <d-list-group flush>
          <d-list-group-item class="p-3">
            <d-row>
              <d-col>
                <product-form ref="productForm" :model.sync="model"/>
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
        <confirmation-modal
          :cancel="close"
          :confirm="callback"
          :title="confirmation[type].title"
          :message="confirmation[type].message"/>
      </d-card>
    </d-col>
    <!-- Sidebar Widgets -->
    <d-col lg="3" md="12">
      <sidebar-actions :model.sync="model" @save="save" @printQr="printQr"/>
    </d-col>
  </d-row>
</template>

<script>
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import ProductForm from './ProductForm.vue';
import ProductActions from './ProductActions';
import SidebarActions from '../components/SidebarActions.vue';
import {
  _SAVE_PRODUCT_SUCCESS_,
  _LOAD_MODEL_,
  MODEL,
  OPTIONS_CONFIRMATION_MODAL,
} from './ProductModel';

export default {
  name: 'product-page',
  mixins: [ProductActions],
  props: {},
  components: {
    Loader,
    ProductForm,
    SidebarActions,
    ConfirmationModal,
  },
  data() {
    return {
      type: 'product',
      model: MODEL,
      object: null,
      loading: false,
      message: null,
      confirmation: OPTIONS_CONFIRMATION_MODAL,
    };
  },
  computed: {},
  methods: {
    printQr() {
      this.$refs.productForm.printQr();
    },
    save() {
      this.$refs.productForm.save();
    },
  },
  mounted() {
    Events.$on('loading', loading => {
      this.loading = loading;
    });
    Events.$on(_LOAD_MODEL_, model => {
      this.model = model;
    });
    Events.$on(_SAVE_PRODUCT_SUCCESS_, product => {
      this.$router.push(`/admin/produtos/${product.id}`);
      this.model = product;
    });
  },
};
</script>

<style lang="scss" scoped>
.control__button {
  display: flex;
  justify-content: flex-start;
}
</style>
